<div class="page-divider"></div>
<div>
    <div class="footer-question">{{ question | i18next }}</div>
    <ham-button class="footer-action-button" (buttonClick)="onButtonClicked()" variant="white">
        {{ actionButton.title | i18next }}
    </ham-button>
</div>
